// Environment-based API configuration
export const base_url = process.env.REACT_APP_API_BASE_URL || 
  "http://127.0.0.1:5001/p-dashboard-server/us-central1/api/";

// Fallback URLs for different environments
export const API_URLS = {
  development: "http://127.0.0.1:5001/p-dashboard-server/us-central1/api/",
  production: "https://api-4tt66lapca-uc.a.run.app/",
  staging: "https://api-4tt66lapca-uc.a.run.app/" // Same as production for now
};
